/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A fluid ounce measures volume (used for cups and pints), while a regular ounce measures weight. They coincide closely for water, where 1 fluid ounce weighs close to 1 ounce, but that breaks down for denser or lighter liquids like honey or oil.`)
};

const es_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Una onza de fluido mide volumen (usada para tazas y pintas), mientras que una onza regular mide peso. Coinciden cercanamente para el agua, donde 1 onza de fluido pesa cercano a 1 onza, pero eso se rompe para líquidos más densos o más ligeros como miel o aceite.`)
};

const de_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Eine Fluid Ounce misst Volumen (verwendet für Cups und Pints), während eine gewöhnliche Unze Gewicht misst. Bei Wasser stimmen sie annähernd überein, wo 1 Fluid Ounce nahe an 1 Unze wiegt, aber das gilt nicht mehr bei dichteren oder leichteren Flüssigkeiten wie Honig oder Öl.`)
};

const nl_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Een vloeistof-ounce meet volume (gebruikt voor kopjes en pints), terwijl een normale ounce gewicht meet. Zij vallen dicht samen voor water, waar 1 vloeistof-ounce dicht in de buurt weegt van 1 ounce, maar dat valt uiteen voor dichtere of lichtere vloeistoffen zoals honing of olie.`)
};

const fr_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Une once liquide mesure le volume (utilisée pour les tasses et les pintes), tandis qu'une once régulière mesure le poids. Elles coïncident étroitement pour l'eau, où 1 once liquide pèse proche de 1 once, mais cela se décompose pour les liquides plus denses ou plus légers comme le miel ou l'huile.`)
};

const it_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Un'oncia fluida misura il volume (utilizzato per tazze e pinte), mentre un'oncia normale misura il peso. Coincidono da vicino per l'acqua, dove 1 oncia fluida pesa vicino a 1 oncia, ma si rompe per liquidi più densi o più leggeri come miele o olio.`)
};

const pt_br2_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma onça fluida mede volume (usada para xícaras e pintas), enquanto uma onça regular mede peso. Elas coincidem de perto para água, onde 1 onça fluida pesa próximo a 1 onça, mas isso se desintegra para líquidos mais densos ou mais leves como mel ou óleo.`)
};

const pt_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma onça fluida mede volume (utilizada para chávenas e pintas), enquanto uma onça regular mede peso. Coincidem de perto para água, onde 1 onça fluida pesa perto de 1 onça, mas isto desfaz-se para líquidos mais densos ou mais leves como mel ou óleo.`)
};

const ja_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。液量オンスは体積を測定します(カップとパイントで使用)、通常のオンスは質量を測定します。それらは水に近く一致しており、1液量オンスは約1オンスの重さがあります。ただし、ハチミツまたは油のようなより濃い、より明るい液体ではそれが壊れます。`)
};

const zh_uc_vol_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq3_a", locale)
	if (locale === "en") return en_uc_vol_faq3_a(inputs)
	if (locale === "es") return es_uc_vol_faq3_a(inputs)
	if (locale === "de") return de_uc_vol_faq3_a(inputs)
	if (locale === "nl") return nl_uc_vol_faq3_a(inputs)
	if (locale === "fr") return fr_uc_vol_faq3_a(inputs)
	if (locale === "it") return it_uc_vol_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq3_a(inputs)
	if (locale === "pt") return pt_uc_vol_faq3_a(inputs)
	if (locale === "ja") return ja_uc_vol_faq3_a(inputs)
	return zh_uc_vol_faq3_a(inputs)
};